export default __webpack_public_path__ + "static/media/img_sazib.c49e72f3.png";